import { render, staticRenderFns } from "./EventSidebarButton.vue?vue&type=template&id=6659f199&scoped=true&"
import script from "./EventSidebarButton.vue?vue&type=script&lang=js&"
export * from "./EventSidebarButton.vue?vue&type=script&lang=js&"
import style0 from "./EventSidebarButton.vue?vue&type=style&index=0&id=6659f199&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6659f199",
  null
  
)

export default component.exports